import SettingFrame from "../../../../../components/@settings/SettingFrame"
import NewTask from "../../../../../components/@schedulers/tasks/NewTask";

import { routeTypes } from "../../../../../hooks/useSystemRoutes";

export default function TaskNewPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <NewTask 
                routeType={routeType}
            />
        </SettingFrame>
    )
}       